import { render, staticRenderFns } from "./UserTransferLog.vue?vue&type=template&id=dba094d0&scoped=true"
import script from "./UserTransferLog.vue?vue&type=script&lang=js"
export * from "./UserTransferLog.vue?vue&type=script&lang=js"
import style0 from "./UserTransferLog.vue?vue&type=style&index=0&id=dba094d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba094d0",
  null
  
)

export default component.exports